<template>
  <div class="rs-title-icon">
    <h4>
      {{ text }}
    </h4>
    <!-- The @click will emit clicked that can be called in parent components -->
    <RsButton
      v-show="isUpdatePermitted"
      class="rs-title-button"
      icon="pencil"
      weight="far"
      hollow
      @click="$emit('click')"
    />
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'RsTitleIcon',
  props: {
    text: String,
  },

  emits: ['click'],
});
</script>

<style lang="scss" scoped>
@import "@/styles/_variables.scss";

.rs-title-icon {
  position: relative;
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
  h4{
    margin: 0;
  }

  .rs-button {
    color: $tertiary-gray;
    border-color: transparent;
    &:hover {
      background-color: transparent;
      color: $secondary-color;
    }
  }
}
</style>
